export interface RecordingTrackMix {
  volume: number
  muted: boolean
  solo: boolean
}

const DEFAULT_MIX: RecordingTrackMix = { volume: 1, muted: false, solo: false }

export function clampTrackVolume(value: number): number {
  if (!Number.isFinite(value)) return 1
  return Math.min(1, Math.max(0, value))
}

/**
 * solo 트랙이 하나라도 있으면 solo 트랙만 audible.
 * solo가 없으면 mute되지 않은 트랙이 audible.
 */
export function audibleTrackKeys(
  trackKeys: readonly string[],
  mixByKey: Readonly<Record<string, RecordingTrackMix>>,
): string[] {
  const soloKeys = trackKeys.filter((key) => (mixByKey[key] ?? DEFAULT_MIX).solo)
  const candidates = soloKeys.length > 0 ? soloKeys : [...trackKeys]
  return candidates.filter((key) => !(mixByKey[key] ?? DEFAULT_MIX).muted)
}
